/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SwitchButtonModule} from '../../../../shared/switch-button/switch-button.module';
import {InputToggleTextComponent} from './input-toggle-text/input-toggle-text.component';
import {InputToggleDropdownComponent} from './input-toggle-dropdown/input-toggle-dropdown.component';
import {PipesModule} from '../../../../shared/pipes/pipes.module';
import {InputFilterModule} from '../../../../shared/filter/input-filter/input-filter.module';
import {InputModule} from '../../../../shared/input/input.module';

@NgModule({
    declarations: [InputToggleTextComponent, InputToggleDropdownComponent],
    imports: [
        CommonModule,
        SwitchButtonModule,
        PipesModule,
        InputFilterModule,
        InputModule
    ],
    exports: [InputToggleTextComponent, InputToggleDropdownComponent]
})
export class BundlingSettingsInputsModule {
}
